export default {
  SIDEBAR_CLICKED: 'Refer & Earn Sidebar Clicked',
  PAGE_VIEWED: 'Refer & Earn Page Viewed',
  SLIDO_VIEWED: 'Refer & Earn Slido Viewed',
  ATTEMPTED: 'Refer Lead Creation Attempted',
  COMPLETED: 'Refer Lead Creation Completed',
  FAILED: 'Refer Lead Creation Failed',

  ANNOUNCEMENT_VIEWED: 'Refer & Earn Launch Viewed',
  ANNOUNCEMENT_CTA_CLICKED: 'Refer & Earn Launch CTA Clicked',
};
